// Sorting is driven by the filters drawer, not by column headers, so no column is sortable.
export const COLUMNS = [
  { id: 'username', label: 'Username' },
  { id: 'hostUsername', label: 'Host Username' },
  { id: 'inTime', label: 'Clock In' },
  { id: 'inCoordinates', label: 'Clock In (GPS Location)' },
  { id: 'outTime', label: 'Clock Out' },
  { id: 'outCoordinates', label: 'Clock Out (GPS Location)' },
];

export const USER_SEARCH_KEYS = ['username', 'employeeNum', 'fullName'];
